export const SMALL_GROUP_MAX_MEMBER_COUNT = 80;
export const SMALL_GROUP_MEMBER_COUNT_WARNING_THRESHOLD =
  SMALL_GROUP_MAX_MEMBER_COUNT - 10;
export const MEDIUM_GROUP_MAX_MEMBER_COUNT = 500;
export const MEDIUM_GROUP_MAX_MEMBER_COUNT_WARNING_THRESHOLD =
  MEDIUM_GROUP_MAX_MEMBER_COUNT - 20;
